"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Global = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("styled-components");
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var Global = (0, _styledComponents.createGlobalStyle)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    body {\n        background: ", ";\n        font-size: ", ";\n        color: ", ";\n        width: 100%;\n        height: 100%;\n        margin:0;\n        padding: 0;\n    }\n    *{\n        box-sizing: border-box;\n    }\n    a{\n        text-decoration: none;\n    }\n"])), function (props) {
  return props.theme.PrimaryFade;
}, function (props) {
  return props.theme.PrimaryFontSize;
}, function (props) {
  return props.theme.PrimaryFontColor;
});
exports.Global = Global;